import React from 'react';
import { ShieldCheck, CheckCircle, Download, MonitorSmartphone, Lock } from 'lucide-react';
import { CTAButton } from './CTAButton';
interface PurchaseSectionProps {
  id?: string;
  showFooter?: boolean;
}
export function PurchaseSection({
  id,
  showFooter = false
}: PurchaseSectionProps) {
  return <section id={id} className="py-6 md:py-12 px-4 bg-dark-800" data-id="element-92">
      <div className="max-w-xl mx-auto bg-dark-900 rounded-2xl shadow-xl border border-dark-700 overflow-hidden" data-id="element-93">
        {/* Header badge */}
        <div className="bg-brand-500 py-2 text-center" data-id="element-94">
          <h3 className="text-sm md:text-base font-black uppercase tracking-wider text-white" data-id="element-95">
            🔥 OFERTA DE LANZAMIENTO
          </h3>
        </div>

        <div className="p-5 md:p-6 text-center" data-id="element-96">
          <h4 className="text-lg md:text-xl font-black text-white mb-2 leading-tight" data-id="element-97">
            Manual Académico de Programación
          </h4>

          <p className="text-sm md:text-base text-brand-300 font-medium mb-4 px-2" data-id="element-98">
            <span className="font-bold text-white" data-id="element-99">
              TODO el material de Programación I a IV
            </span>{' '}
            listo para usar: clases, diapositivas, material teorico resumido,
            actividades y juegos didácticos, trabajos practicos y evaluaciones.
          </p>

          {/* Price */}
          <div className="mb-4" data-id="element-100">
            <p className="text-gray-500 font-bold line-through text-base" data-id="element-101">
              $79.990 ARS
            </p>
            <p className="text-4xl md:text-5xl font-black text-brand-400 leading-none" data-id="element-102">
              $19.990<span className="text-xl" data-id="element-103"> ARS</span>
            </p>
            <p className="text-xs font-bold text-gray-400 uppercase tracking-wider mt-1" data-id="element-104">
              Pago único • Acceso inmediato
            </p>
          </div>

          {/* Benefits row */}
          <div className="flex flex-wrap justify-center gap-x-3 gap-y-1 mb-4 text-xs font-semibold text-gray-300" data-id="element-105">
            <span className="flex items-center gap-1" data-id="element-106">
              <Download className="text-brand-400" size={14} data-id="element-107" />
              Descarga inmediata
            </span>
            <span className="flex items-center gap-1" data-id="element-108">
              <CheckCircle className="text-brand-400" size={14} data-id="element-109" />
              Acceso de por vida
            </span>
            <span className="flex items-center gap-1" data-id="element-110">
              <MonitorSmartphone className="text-brand-400" size={14} data-id="element-111" />
              Celular y PC
            </span>
          </div>

          <CTAButton isCheckout={true} className="w-full text-base md:text-lg py-3" data-id="element-112" />

          <div className="flex items-center justify-center gap-2 mt-3 text-xs font-medium text-[#93959C]" data-id="element-113">
            <Lock size={12} data-id="element-114" /> Pago 100% seguro
            <span className="mx-1" data-id="element-115">•</span>
            <ShieldCheck size={12} className="text-brand-400" data-id="element-116" /> Garantía 7 días
          </div>
        </div>
      </div>

      {showFooter && <div className="text-center mt-8 max-w-2xl mx-auto space-y-3 text-gray-400 font-medium text-base px-2" data-id="element-117">
          <p data-id="element-118">
            <span className="text-red-400 font-bold" data-id="element-119">
              El precio actual es únicamente por lanzamiento.
            </span>{' '}
            Este sistema continuará creciendo con nuevos contenidos, nuevas
            clases, nuevas diapositivas y nuevos recursos para docentes de
            Programación.
          </p>
          <p data-id="element-120">Y cuando eso ocurra, el valor del acceso aumentará.</p>
          <p className="text-gray-200 font-bold mt-4" data-id="element-121">
            Los docentes que ingresen hoy conservan el precio actual y obtienen
            acceso completo a todas las actualizaciones futuras.
          </p>
        </div>}
    </section>;
}